import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics-ranking-top-canonicals',
  templateUrl: './semantics-ranking-top-canonicals.component.html',
  styleUrl: './semantics-ranking-top-canonicals.component.scss',
})
export class SemanticsRankingTopCanonicalsComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsRankingTopicsCanonicals');
    });
  }

  get data() {
    return (
      this.analyticsService.semanticsRankingTopicsCanonicals$.value?.top_canonicals
        ?.slice(0, 10)
        .map((item) => ({
          label: item.canonical,
          value: item.count,
        })) || []
    );
  }
}
